import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Accordion = ({
  accordionOpen,
  setAccordionOpen,
  children,
  headText,
  callbackText,
  hasBgColor,
  bgColor,
}) => (
  <S.AccordionContainer>
    <S.AccordionHead
      hasBgColor={hasBgColor}
      bgColor={bgColor}
      onClick={() => setAccordionOpen(!accordionOpen)}
    >
      <S.AccordionHeadTitle hasBgColor={hasBgColor}>
        {headText}
      </S.AccordionHeadTitle>
      <S.AccordionHeadIcon
        hasBgColor={hasBgColor}
        isAccordionOpen={accordionOpen}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="14"
          viewBox="0 0 13 8"
          fill="none"
        >
          <path d="M1 1L6.5 6.5L12 1" stroke="#0083CA" />
        </svg>
      </S.AccordionHeadIcon>
    </S.AccordionHead>
    <S.AccordionContent isAccordionOpen={accordionOpen}>
      {children && Object.keys(children).length ? (
        children
      ) : (
        <S.AccordionCallback>
          <p>{callbackText}</p>
        </S.AccordionCallback>
      )}
    </S.AccordionContent>
  </S.AccordionContainer>
);

export default Accordion;

Accordion.defaultProps = {
  callbackText: 'Não existem informações',
  hasBgColor: false,
  bgColor: 'transparent',
};

Accordion.propTypes = {
  accordionOpen: PropTypes.bool.isRequired,
  setAccordionOpen: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  headText: PropTypes.string.isRequired,
  callbackText: PropTypes.string,
  hasBgColor: PropTypes.bool,
  bgColor: PropTypes.string,
};
